<template>
  <div>
    <div>
      <vx-card  title="Total pagos" class="columna">
        <!-- <p class="font-bold text-2xl">Total: 5</p> -->
        <div class="vx-row mt-3">
          <div class="vx-col w-full sm:w-full md:w-full  lg:w-full  xl:w-full  mb-6">
            <div class="flex items-center bg-white border rounded-sm overflow-hidden shadow h-full">
              <div class="p-4 bg-success">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 7.5h-.75A2.25 2.25 0 0 0 4.5 9.75v7.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-7.5a2.25 2.25 0 0 0-2.25-2.25h-.75m-6 3.75 3 3m0 0 3-3m-3 3V1.5m6 9h.75a2.25 2.25 0 0 1 2.25 2.25v7.5a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-.75" />
                </svg>
              </div>
              <div class="px-4 text-gray-700">
                  <h3 class="text-sm tracking-wider">Total Pagos </h3>
                  <p class="text-3xl">{{ totalPagos | filtrarDecimal }}</p>
              </div>
            </div>
          </div>
          <div>
            <b>Total Anticipos:</b>
            <p>{{ datosReport.totalAnticipos | filtrarDecimal }}</p>
            <b>Total Liquidaciones:</b>
            <p>{{ datosReport.totalLiquidaciones | filtrarDecimal }}</p>
            <b>Total otros valores a cancelar:</b>
            <p>{{ datosReport.totalOtrosValores | filtrarDecimal }}</p>
            <b>Total Convenio:</b>
            <p>{{ datosReport.totalConvenio | filtrarDecimal }}</p>
            <b>Total Anticipo del pedido:</b>
            <p>{{ datosReport.totalAnticipoAprobado | filtrarDecimal }}</p>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return{
      datosReport:'',
      totalPagos:0,
    }
  },
  props:{
    periodo_id:{
      type:Number,
      default:0
    },
  },
  watch:{
    periodo_id(results){
      this.getReporte()
    }
  },
  mounted(){
    let me = this
    me.getReporte()
  },
  methods:{
    getReporte(){
      let me = this
      this.$http.get(this.$server_url+`pedigo_Pagos?getTotalDocumentosLiq=1&idPeriodo=${me.periodo_id}`)
        .then(function (res) {
          if(res.data.status == 0){
            me.$vs.notify({
            text:'No se encontro datos',
            color:'warning',
            iconPack: 'feather',
            icon:'icon-check'})
            return
          }
          me.datosReport = res.data[0]
          const { totalAnticipos,  totalLiquidaciones, totalOtrosValores,totalConvenio, totalAnticipoAprobado }  = me.datosReport
          me.totalPagos = totalAnticipos + totalLiquidaciones + totalOtrosValores + totalConvenio + totalAnticipoAprobado
        })
        .catch(function (error) {
            console.log(error + ' error');
        })
    },
  }
}
</script>
